import React, { Component } from 'react';
import AlertComponent from '../common/alertComponent';
import DatePickerComponent from '../common/datePickerComponent';
import AgGridComponent from '../common/agGridComponent';
import { getHyphenDDMMMYYYYHHMM } from '../common/utils';
var redirectURL = require('../redirectURL');
var moment = require('moment');

// Billing starts from this month; everything invoiced before it was billed outside this flow
var FIRST_BILLING_MONTH = moment('2026-10-01', 'YYYY-MM-DD').toDate();

// Second tab of the Billing Report: generate the monthly bill and view billed records.
// A record is billed once it is Delivered; records not delivered by month end roll into a later month.
export default class BillingGeneration extends Component {

	constructor(props){
		super(props);
		var previousMonth = moment().subtract(1, 'month').startOf('month').toDate();
		var defaultMonth = previousMonth < FIRST_BILLING_MONTH ? FIRST_BILLING_MONTH : previousMonth;
		this.state = {
			billMonth: defaultMonth,
			rowData: [],
			summary: { billed_count: 0, legacy_count: 0, pending_count: 0, times_generated: 0, can_generate: false },
			loadshow: 'show-n',
			alert: null
		}
	}

	componentDidMount(){
		this.loadBillData();
	}

	// Only admin / ORGUSER can generate bills
	isBillingAdmin = () => {
		var userType = String(localStorage.getItem("user_type") || "").toLowerCase();
		return userType == "admin" || userType == "orguser";
	}

	getBillMonthKey = () => {
		return moment(this.state.billMonth).format("YYYY-MM");
	}

	isCurrentOrFutureMonth = () => {
		return this.getBillMonthKey() >= moment().format("YYYY-MM");
	}

	getUserScope = () => {
		var scope = {};
		if (localStorage.getItem("user_type") == "TRANSPORTER") {
			scope.serviceProviders = JSON.parse(localStorage.getItem('transportercode'));
		}
		if (localStorage.getItem("user_type") == "COURIER_CONSIGNEE") {
			scope.courierConsigneeCode = localStorage.getItem("consignee_code");
		}
		return scope;
	}

	showMessage = (title, type) => {
		this.setState({
			alert: <AlertComponent type={type} title={title} onConfirm={this.hideAlert} />
		});
	}

	hideAlert = () => {
		this.setState({ alert: null });
	}

	loadBillData = () => {
		var params = Object.assign({ bill_month: this.getBillMonthKey() }, this.getUserScope());
		this.setState({ loadshow: 'show-m' });
		redirectURL.post("/consignments/getCourierBillData", params)
		.then((response) => {
			var data = response.data;
			if (data.status == "success") {
				this.setState({
					rowData: data.records,
					summary: {
						billed_count: data.billed_count,
						legacy_count: data.legacy_count,
						pending_count: data.pending_count,
						times_generated: data.times_generated,
						can_generate: data.can_generate
					},
					loadshow: 'show-n'
				});
			}
			else {
				this.setState({ rowData: [], loadshow: 'show-n' });
				this.showMessage(data.message || "Unable to load bill data", "danger");
			}
		})
		.catch((e) => {
			console.log(e);
			this.setState({ loadshow: 'show-n' });
			this.showMessage("Unable to load bill data", "danger");
		});
	}

	onClickGenerate = () => {
		this.setState({
			alert: <AlertComponent
				confirm
				confirmBtnText="Generate"
				confirmBtnBsStyle="success"
				title={"Generate bill for " + moment(this.state.billMonth).format("MMMM YYYY") + "?"}
				onConfirm={this.generateBill}
				onCancel={this.hideAlert}
			>
				{this.state.summary.pending_count} delivered consignments will be marked as billed.
			</AlertComponent>
		});
	}

	generateBill = () => {
		this.hideAlert();
		this.setState({ loadshow: 'show-m' });
		var params = {
			bill_month: this.getBillMonthKey(),
			email: localStorage.getItem("email")
		};
		redirectURL.post("/consignments/generateCourierBill", params)
		.then((response) => {
			var data = response.data;
			this.setState({ loadshow: 'show-n' });
			if (data.status == "success") {
				this.showMessage(data.message, "success");
				this.loadBillData();
			}
			else {
				this.showMessage(data.message || "Bill generation failed", "warning");
			}
		})
		.catch((e) => {
			console.log(e);
			this.setState({ loadshow: 'show-n' });
			this.showMessage("Bill generation failed", "danger");
		});
	}

	getExportFileName = () => {
		return "Courier_Bill_" + this.getBillMonthKey();
	}

	onClickExportExcel = () => {
		this.grid.exportExcel(this.getExportFileName(), "Bill");
	}

	onClickExportCsv = () => {
		this.grid.exportCsv(this.getExportFileName());
	}

	// Same data columns as the Billing Report grid (action / button columns left out),
	// with the billing columns placed right after the Status column
	getColumnDefs = () => {
		var reportColumns = (this.props.reportColumns || []).filter(function(col){
			var isButtonColumn = col.cellRenderer || col.cellRendererSelector;
			return col.headerName && !isButtonColumn;
		});

		var billColumns = [
			{
				headerName: "Bill Status",
				field: "bill_status",
				width: 130,
				cellStyle: function(params){
					return { color: params.value == "Pending" ? "#d9822b" : "green" };
				}
			},
			{
				headerName: "Bill Month",
				field: "bill_month",
				width: 110,
				valueGetter: function(params){ return params.data.bill_month ? params.data.bill_month : "" }
			},
			{
				headerName: "Bill Generated On",
				field: "bill_generated_on",
				width: 160,
				valueGetter: function(params){ return getHyphenDDMMMYYYYHHMM(params.data.bill_generated_on) }
			},
			{
				headerName: "Bill Generated By",
				field: "bill_generated_by",
				width: 200,
				valueGetter: function(params){ return params.data.bill_generated_by ? params.data.bill_generated_by : "" }
			},
			{
				headerName: "Bill Batch No",
				field: "bill_batch_no",
				width: 110,
				valueGetter: function(params){ return params.data.bill_batch_no ? params.data.bill_batch_no : "" }
			},
			{ headerName: "Times Bill Generated (Month)", field: "bill_times_generated", width: 190 }
		];

		var statusIndex = reportColumns.findIndex(function(col){ return col.field == "consignment_status" });
		if (statusIndex < 0) {
			return reportColumns.concat(billColumns);
		}
		return reportColumns.slice(0, statusIndex + 1).concat(billColumns, reportColumns.slice(statusIndex + 1));
	}

	render(){
		var summary = this.state.summary;
		var isAdmin = this.isBillingAdmin();
		var generateDisabled = !isAdmin || !summary.can_generate;
		var generateTitle = "";
		if (this.isCurrentOrFutureMonth()) {
			generateTitle = "Bill can be generated only after the month is completed";
		}
		else if (summary.pending_count == 0) {
			generateTitle = "No delivered records pending for billing";
		}

		var columnDefs = this.getColumnDefs();

		return (
			<div>
				{this.state.alert}
				<div className="card">
					<div className="row card-body" style={{ padding: "10px 30px" }}>
						<div className="form-group col-xl-3 col-lg-3 col-md-6 col-12">
							<label>Bill Month</label>
							<DatePickerComponent
								mode="month"
								selected={this.state.billMonth}
								onChange={(date) => this.setState({ billMonth: date })}
								minDate={FIRST_BILLING_MONTH}
								maxDate={new Date()}
							/>
						</div>
						<div className="form-group col-xl-2 col-lg-3 col-md-6 col-12 d-flex align-items-end">
							<button type="button" className="btn btn-success" onClick={this.loadBillData}
								style={{ height: "36px", padding: "0 16px", marginBottom: "4px", borderRadius: "6px", fontSize: "13px", fontWeight: 500, lineHeight: "1" }}>
								Submit
							</button>
						</div>
						{isAdmin ?
						<div className="form-group col-xl-7 col-lg-6 col-12 d-flex align-items-end justify-content-end">
							<span title={generateTitle}>
								<button type="button" className="btn btn-warning" onClick={this.onClickGenerate} disabled={generateDisabled}
									style={{ height: "36px", padding: "0 16px", marginBottom: "4px", borderRadius: "6px", fontSize: "13px", fontWeight: 500, lineHeight: "1" }}>
									Generate Bill
								</button>
							</span>
						</div>
						: ""}
					</div>
				</div>

				<div className="card">
					<div className="card-header">
						<span style={{ marginRight: "20px" }}>Billed: <b>{summary.billed_count}</b></span>
						<span style={{ marginRight: "20px" }}>Billed (Legacy): <b>{summary.legacy_count}</b></span>
						<span style={{ marginRight: "20px" }}>Pending: <b>{summary.pending_count}</b></span>
						<span>Times bill generated for this month: <b>{summary.times_generated}</b></span>
						<span className="float-right">
							<button type="button" className="btn btn-info" onClick={this.onClickExportExcel}
								style={{ borderRadius: "6px", padding: "5px 12px", fontSize: "13px", marginRight: "10px" }}>
								Export Excel
							</button>
							<button type="button" className="btn btn-info" onClick={this.onClickExportCsv}
								style={{ borderRadius: "6px", padding: "5px 12px", fontSize: "13px" }}>
								Export CSV
							</button>
						</span>
					</div>
					<div className="card-body" style={{ position: "relative" }}>
						<AgGridComponent
							ref={(grid) => this.grid = grid}
							columnDefs={columnDefs}
							rowData={this.state.rowData}
						/>
						<div className={"dataLoadpage " + (this.state.loadshow)}></div>
						<div className={"dataLoadpageimg " + (this.state.loadshow)}>
							<div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
